import { useContext } from 'react';
import MailDocumentationContext from 'src/contexts/mailDocumentation/mailDocumentationContext';

const useMailDocumentation = () => useContext(MailDocumentationContext);

export default useMailDocumentation;
